<router-outlet></router-outlet>
<ng-container *ngIf="!acaoCarregada">
    <h3>Consultar Exercícios</h3>
    <a href="#" class="sr-only">Consultar Exercícios</a>
    <div class="row" *ngIf="vinculoSelecionado">
        <div class="col-sm-12">
            <div class="br-card bg-gray-5">
                <div class="card-content">
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-nome">Nome</label>
                            <p id="campo-nome">{{ vinculoSelecionado.nome }}</p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-cpf">CPF</label>
                            <p id="campo-cpf">{{ vinculoSelecionado.cpf | cpf }}</p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-matriculacargo">Matrícula/Cargo</label>
                            <p id="campo-matriculacargo">
                                {{ (vinculoSelecionado.matricula ? vinculoSelecionado.matricula : "") + " - " + (vinculoSelecionado.descricaoCargo ? vinculoSelecionado.descricaoCargo : "") }}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-situacao-funcional">Situação Funcional</label>
                            <p id="campo-situacao-funcional">
                                {{ (vinculoSelecionado.siglaRegime ? vinculoSelecionado.siglaRegime : "") + " - " + (vinculoSelecionado.descricaoSituacaoFuncional ? vinculoSelecionado.descricaoSituacaoFuncional : "") }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-situacao-vinculo">Situacao do Vínculo</label>
                            <p id="campo-situacao-vinculo">
                                {{ situacaoVinculo ? "Ativo" : "Encerrado" }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-orgao">Órgão</label>
                            <p id="campo-orgao">
                                {{ vinculoSelecionado.codigoOrgao + (vinculoSelecionado.siglaOrgao ? " - " + vinculoSelecionado.siglaOrgao : "") + " - " + vinculoSelecionado.descricaoOrgao }}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-tipo-aquisicao-ferias">Tipo de Aquisição de Férias Atual</label>
                            <p id="campo-tipo-aquisicao-ferias">
                                {{ (vinculoSelecionado.codigoTipoAquisicaoFerias ? vinculoSelecionado.codigoTipoAquisicaoFerias : "") + " - " + (vinculoSelecionado.descricaoTipoAquisicaoFerias ? vinculoSelecionado.descricaoTipoAquisicaoFerias : "") }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-chefia-imediata">Chefia Imediata Atual/UORG</label>
                            <p id="campo-chefia-imediata">
                                {{ (vinculoSelecionado.nomeChefiaImediata ? vinculoSelecionado.nomeChefiaImediata : "") + " - " + (vinculoSelecionado.codigoUorgChefiaImediata ? vinculoSelecionado.codigoUorgChefiaImediata : "") }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-4 mt-2">
                            <label for="campo-orgao-exercicio">Órgão em Exercício</label>
                            <p id="campo-orgao-exercicio">
                                {{ (vinculoSelecionado.codigoOrgaoExercicio ? vinculoSelecionado.codigoOrgaoExercicio : "") + " - " + (vinculoSelecionado.siglaOrgaoExercicio ? vinculoSelecionado.siglaOrgaoExercicio : "") + " - " + (vinculoSelecionado.descricaoOrgaoExercicio ? vinculoSelecionado.descricaoOrgaoExercicio : "") }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row mt-2">
                        <div class="col text-right">
                            <button aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="secondary mr-2" (click)="voltar()"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="my-2 text-semi-bold" *ngIf="exerciciosFerias && exerciciosFerias.length > 0">Total de Registros Encontrados: {{ totalItensResultado }}</div>
    <div class="row br-table" *ngIf="exerciciosFerias && exerciciosFerias.length > 0">
        <div class="col">
            <p-table #pTableResultado [value]="exerciciosFerias" [autoLayout]="true" responsiveLayout="stack" rowGroupMode="rowspan" groupRowsBy="exercicio" sortField="exercicio" [sortOrder]="-1">
                <ng-template pTemplate="header">
                    <tr>
                        <th id="cabecalho-exercicio" pSortableColumn="ano">
                            Exercício
                            <p-sortIcon field="ano"></p-sortIcon>
                            <p-columnFilter field="ano" matchMode="in" [showMenu]="false" (click)="$event.stopPropagation()">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="anosExercicios" styleClass="mt-1" [filter]="false" (onChange)="filter($event.value)" [overlayOptions]="{ appendTo: 'body' }" [showToggleAll]="false" [showHeader]="false" [maxSelectedLabels]="1" selectedItemsLabel="{0} exercícios selecionados">
                                        <ng-template pTemplate="filtericon">
                                            <span class="fas fa-search"></span>
                                        </ng-template>
                                        <ng-template pTemplate="checkicon">
                                            <span class="fas fa-check"></span>
                                        </ng-template>
                                        <ng-template pTemplate="dropdownicon">
                                            <span class="fas fa-chevron-down"></span>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th id="cabecalho-inicioaquisitivo" pSortableColumn="dataInicioPeriodoAquisitivo">
                            Início Aquis.
                            <p-sortIcon field="dataInicioPeriodoAquisitivo"></p-sortIcon>
                        </th>
                        <th id="cabecalho-fimaquisitivo" pSortableColumn="dataFimPeriodoAquisitivo">
                            Fim Aquis.
                            <p-sortIcon field="dataFimPeriodoAquisitivo"></p-sortIcon>
                        </th>
                        <th id="cabecalho-dias" pSortableColumn="quantidadeDias">
                            Dias
                            <p-sortIcon field="quantidadeDias"></p-sortIcon>
                        </th>
                        <th id="cabecalho-situacao" pSortableColumn="situacao">
                            Situação
                            <p-sortIcon field="situacao"></p-sortIcon>
                            <p-columnFilter field="situacao" matchMode="equals" [showMenu]="false" (click)="$event.stopPropagation()">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-dropdown [options]="situacoesFerias" [ngModel]="value" (keydown)="$event.stopPropagation()" (onChange)="filter($event.value)" [removeClearButton]="true" [overlayOptions]="{ appendTo: 'body' }">
                                        <ng-template pTemplate="dropdownicon">
                                            <span class="fas fa-chevron-down"></span>
                                        </ng-template>
                                    </p-dropdown>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <th id="cabecalho-parcela">Parcela</th>
                        <th id="cabecalho-dias">Dias</th>
                        <th id="cabecalho-inicio">Início</th>
                        <th id="cabecalho-fim">Fim</th>
                        <th id="cabecalho-situacao">Situação Parc</th>
                        <!--th id="cabecalho-adiantsal">Adiant. Sal</th>
                        <th id="cabecalho-adiant13">Adiant. 13º</th-->
                        <th id="cabecalho-acoes" class="text-center" style="width: 150px">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-registro>
                    <tr>
                        <!--[pSelectableRow]="registro"-->
                        <td style="display: none"></td>
                        <td headers="cabecalho-exercicio">
                            <p class="m-0 text-weight-medium">
                                <span class="p-column-title">
                                    Exercício
                                    <br />
                                </span>
                                {{ registro.ano }}
                                <i *ngIf="registro.indicadorFeriasEspeciais && (registro.indicadorFeriasEspeciais.sigla == 'ASP' || registro.indicadorFeriasEspeciais.sigla == 'ACP')" [title]="registro.indicadorFeriasEspeciais.textoAlternativo" class="fas fa-stamp" style="color: var(--interactive) !important" aria-hidden="true"></i>
                                <i *ngIf="registro.indicadorFeriasEspeciais && (registro.indicadorFeriasEspeciais.sigla == 'JSP' || registro.indicadorFeriasEspeciais.sigla == 'JCP')" [title]="registro.indicadorFeriasEspeciais.textoAlternativo" class="fas fa-gavel" style="color: var(--interactive) !important" aria-hidden="true"></i>
                            </p>
                        </td>
                        <td headers="cabecalho-inicioaquisitivo">
                            <p class="m-0 text-weight-medium">
                                <span class="p-column-title">
                                    Início Aquis.
                                    <br />
                                </span>
                                {{ registro.dataInicioPeriodoAquisitivo | dataFormatada }}
                            </p>
                        </td>
                        <td headers="cabecalho-fimaquisitivo">
                            <p class="m-0 text-weight-medium">
                                <span class="p-column-title">
                                    Fim Aquis.
                                    <br />
                                </span>
                                {{ registro.dataFimPeriodoAquisitivo | dataFormatada }}
                            </p>
                        </td>
                        <td headers="cabecalho-dias">
                            <p class="m-0 text-weight-medium">
                                <span class="p-column-title">
                                    Dias
                                    <br />
                                </span>
                                {{ registro.quantidadeDias }}
                            </p>
                        </td>
                        <td headers="cabecalho-situacao">
                            <p class="m-0 text-weight-medium">
                                <span class="p-column-title">
                                    Situação
                                    <br />
                                </span>
                                {{ registro.situacao }}
                            </p>
                        </td>
                        <!-- COLUNAS DO MODO DESKTOP -->
                        <td headers="cabecalho-parcela" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size: var(--font-size-scale-up-01)">
                                    {{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}
                                </td>
                            </tr>
                        </td>
                        <td headers="cabecalho-dias" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size: var(--font-size-scale-up-01)">
                                    {{ parcela.quantidadeDias }}
                                </td>
                            </tr>
                        </td>
                        <td headers="cabecalho-inicio" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size: var(--font-size-scale-up-01)">
                                    {{ parcela.dataInicio | dataFormatada }}
                                </td>
                            </tr>
                        </td>
                        <td headers="cabecalho-fim" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size: var(--font-size-scale-up-01)">
                                    {{ parcela.dataFim | dataFormatada }}
                                </td>
                            </tr>
                        </td>
                        <td headers="cabecalho-situacao" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size: var(--font-size-scale-up-01)">
                                    {{ parcela.situacao }}
                                </td>
                            </tr>
                        </td>
                        <!--td headers="cabecalho-adiantsal" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size:  var(--font-size-scale-up-01);">{{parcela.adiantamentoSalarial ? 'Sim' : 'Não'}}</td>
                            </tr>
                        </td>
                        <td headers="cabecalho-adiant13" class="desktop-only">
                            <tr *ngFor="let parcela of registro.parcelasEmLinha" class="celulaParcela">
                                <td style="font-size:  var(--font-size-scale-up-01);">{{parcela.adiantamentoDecimoTerceiro ? 'Sim' : 'Não'}}</td>
                            </tr>
                        </td-->
                        <!-- COLUNAS DO MODO MOBILE -->
                        <ng-container *ngFor="let parcela of registro.parcelasEmLinha">
                            <td class="bg-gray-5 mobile-only">
                                <span class="p-column-title">Parcela</span>
                                {{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}
                            </td>
                            <td class="mobile-only">
                                <p class="m-0 text-weight-medium">
                                    <span class="p-column-title">
                                        Quantidade de Dias
                                        <br />
                                    </span>
                                    {{ parcela.quantidadeDias }}
                                </p>
                            </td>
                            <td class="mobile-only">
                                <p class="m-0 text-weight-medium">
                                    <span class="p-column-title">
                                        Início
                                        <br />
                                    </span>
                                    {{ parcela.dataInicio | dataFormatada }}
                                </p>
                            </td>
                            <td class="mobile-only">
                                <p class="m-0 text-weight-medium">
                                    <span class="p-column-title">
                                        Fim
                                        <br />
                                    </span>
                                    {{ parcela.dataFim | dataFormatada }}
                                </p>
                            </td>
                            <td class="mobile-only">
                                <p class="m-0 text-weight-medium">
                                    <span class="p-column-title">
                                        Situação
                                        <br />
                                    </span>
                                    {{ parcela.situacao }}
                                </p>
                            </td>
                            <!--td class="mobile-only">
                                <p class="m-0 text-weight-medium"><span class="p-column-title">Adiant. Sal<br/></span>{{parcela.adiantamentoSalarial ? 'Sim' : 'Não'}}</p>
                            </td>
                            <td class="mobile-only">
                                <p class="m-0 text-weight-medium"><span class="p-column-title">Adiant. 13º<br/></span>{{parcela.adiantamentoDecimoTerceiro ? 'Sim' : 'Não'}}</p>
                            </td-->
                        </ng-container>
                        <td class="coluna-acao" headers="cabecalho-acoes" class="text-center">
                            <p-button [ngClass]="registro.parcelasEmLinha && registro.parcelasEmLinha.length > 0 ? 'p-element' : 'p-element invisivel'" title="Adicionais de Férias" styleClass="m-2 circle" icon="fas fa-dollar-sign" tooltipPosition="left" [pTooltip]="tooltipContent"></p-button>
                            <ng-template #tooltipContent>
                                <table class="infoFinanceira">
                                    <tr>
                                        <th style="padding: 0; white-space: nowrap; width: 60px">Parcela</th>
                                        <th style="padding: 0; white-space: nowrap; width: 80px">Adiant Sal</th>
                                        <th style="padding: 0; white-space: nowrap; width: 80px">Adiant 13º</th>
                                        <th style="padding: 0; white-space: nowrap; width: 80px">Abono Pec</th>
                                    </tr>
                                    <tr *ngFor="let parcela of registro.parcelasEmLinha">
                                        <td style="padding: 0 !important">
                                            {{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}
                                        </td>
                                        <td style="padding: 0 !important">
                                            {{ parcela.adiantamentoSalarial ? "Sim" : "Não" }}
                                        </td>
                                        <td style="padding: 0 !important">
                                            {{ parcela.adiantamentoDecimoTerceiro ? "Sim" : "Não" }}
                                        </td>
                                        <td style="padding: 0 !important">
                                            {{ parcela.abonoPecuniario ? "Sim" : "Não" }}
                                        </td>
                                    </tr>
                                </table>
                            </ng-template>
                            <ng-container *ngIf="registro.acoesPossiveis.length > 0">
                                <p-menu #menu [model]="registro.acoesPossiveis" [popup]="true" appendTo="body" styleClass="menu-acoes-consultar-exercicios" (onShow)="ajustarPosicaoMenuAcoes(menu)"></p-menu>
                                <p-button class="p-element" styleClass="m-2 circle" icon="fas fa-bars" (click)="menu.toggle($event)"></p-button>
                            </ng-container>
                            <!--p-button *ngIf="registro.ano == '2026' || registro.ano == '2025'" class="p-element" styleClass="m-2 circle" icon="fas fa-angle-double-left" (click)="resetarAgentePublico(registro)" title="Voltar para o estado anterior"></p-button-->
                        </td>
                    </tr>
                </ng-template>
                <!--ng-template pTemplate="footer">
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                </ng-template-->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="14">Nenhum resultado encontrado</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</ng-container>
